import SuccessStorySection from "../components/sections/SuccessStorySection";
import { createRef, useState } from "react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import Head from "next/head";
import Link from "next/link";

const data = {
  "Fat Loss": {
    image: "/assets/program1.png",
    text: "Sustainably achieve and maintain healthy body weight with our weight loss program created by expert coaches to develop long-term healthy eating habits to improve your lifestyle with our support.",
  },
  "Muscle Building": {
    image: "/assets/program2.png",
    text: "Suitable for both beginners and Build mass and sculpt your physique to the next level with our muscle-building fitness and nutrition programme.",
  },
  Postpartum: {
    image: "/assets/program3.png",
    text: "Secure a smooth and healthy journey of nourishment for yourself and your baby through all your three trimesters by following our clinical nutrition plans.",
  },
  "Clinical Conditions": {
    image: "/assets/program4.png",
    text: "Combat lifestyle diseases such as PCOS/PCOD, Renal Disorders, Thyroid, Hypertension, Diabetes, Gastrointestinal and Geriatric disorders with clinical nutrition and fitness plans.",
  },
  "Sports Nutrition": {
    image: "/assets/program5.png",
    text: "Enjoy greater strength, endurance, and energy with our sports nutrition and fitness consultation.",
  },
};

const Programs = () => {
  const [step, setStep] = useState("Fat Loss");
  const splide = createRef();

  const clickHandler = (s, index) => {
    setStep(s);
    splide.current.splide.go(index);
  };
  return (
    <div>
      <Head>
        <meta
          property="og:image"
          content={
            "https://assets.alanvidyushbaptist.com/optimumwellness_logo.jpg"
          }
        />
        <meta
          name="description"
          content="Select the right program for you! We create highly personalised, tried & tested fitness and nutrition plans that takes into consideration your current BMI, target weight, fitness goals, calorie needs, macronutrient balance, and dietary preferences."
        />
        <meta name="keywords" content="fitness, health, wellness" />
        <title>
          Choose Your Optimum Wellness Program | Personalised Plans for Your
          Unique Needs
        </title>
      </Head>
      <div className="ps-3 pe-3 ps-lg-5 pe-lg-5 mt-sm-5 mt-xl-0">
        <div className="row m-0 ps-lg-5 pe-lg-5 mb-lg-5">
          <div className="col-sm-4 col-md-5 col-lg-6 m-auto">
            <img
              src="/assets/program.png"
              className="w-100"
              alt="Programs_page"
            />
          </div>
          <div className="col-sm-8 col-md-7 col-lg-6 m-auto">
            <h1 className="fo-70 bco fw-700 lg-50 mfo-28">
              Choose Your Program
            </h1>
            <div className="mt-3 mt-md-5 fo-14 justify d-none d-md-block">
              {" "}
              Optimum Wellness shall help decide your health goals and come up
              with an effective strategy to reach them. When you enroll in one
              of our programmes, our expert fitness coaches and nutritionists
              shall mentor you throughout your complete transformation journey.
              Across this journey, not only shall you reach your goal, but
              you'll also learn how to maintain your health by making educated
              decisions regarding food and exercise and inculcating sustainably
              healthy habits.
            </div>
            <div className="mt-3 mt-md-5 fo-14 justify d-md-none">
              Optimum Wellness shall help decide your health goals and come up
              with an effective strategy to reach them.
            </div>
          </div>
        </div>

        <div className="ps-xl-5 pe-xl-5 mt-5 mt-xl-0">
          <div className="ps-xl-5 pe-xl-5 programs_list d-none d-sm-flex">
            {Object.keys(data).map((s, index) => {
              return (
                <div
                  className={`programs_div cursorPointer ${
                    step == s ? "active" : ""
                  }`}
                  key={index}
                  onClick={() => {
                    setStep(s);
                    splide.current.splide.go(index);
                  }}
                >
                  <div className="programs_item fo-16 fw-700 lg-12">{s}</div>
                </div>
              );
            })}
          </div>

          <div className="ps-xl-5 pe-xl-5 programs_list d-sm-none mb-3">
            <div
              className={`programs_div cursorPointer ${
                "Fat Loss" == step ? "active" : ""
              }`}
              onClick={() => {
                clickHandler("Fat Loss", 0);
              }}
            >
              <div className="programs_item fo-16 fw-700 lg-12 mfo-13">
                Fat Loss
              </div>
            </div>
            <div
              className={`programs_div cursorPointer ${
                "Muscle Building" == step ? "active" : ""
              }`}
              onClick={() => {
                clickHandler("Muscle Building", 1);
              }}
            >
              <div className="programs_item fo-16 fw-700 lg-12 mfo-13">
                Muscle Building
              </div>
            </div>
          </div>

          <div className="ps-xl-5 pe-xl-5 programs_list d-sm-none mb-3">
            <div
              className={`programs_div cursorPointer ${
                "Postpartum" == step ? "active" : ""
              }`}
              onClick={() => {
                clickHandler("Postpartum", 2);
              }}
            >
              <div className="programs_item fo-16 fw-700 lg-12 mfo-13">
                Postpartum
              </div>
            </div>
            <div
              className={`programs_div cursorPointer ${
                "Clinical Conditions" == step ? "active" : ""
              }`}
              onClick={() => {
                clickHandler("Clinical Conditions", 3);
              }}
            >
              <div className="programs_item fo-16 fw-700 lg-12 mfo-13">
                Clinical Conditions
              </div>
            </div>
          </div>

          <div className="ps-xl-5 pe-xl-5 programs_list d-sm-none">
            <div
              className={`programs_div w-100 cursorPointer ${
                "Sports Nutrition" == step ? "active" : ""
              }`}
              onClick={() => {
                clickHandler("Sports Nutrition", 4);
              }}
            >
              <div className="programs_item fo-16 fw-700 lg-12 mfo-13">
                Sports Nutrition
              </div>
            </div>
          </div>

          <Splide
            aria-label="My Favorite Images"
            ref={splide}
            options={{ arrows: false, pagination: false, drag: false }}
          >
            {Object.keys(data).map((s, index) => {
              return (
                <SplideSlide key={index}>
                  <div>
                    <div className="text-center programs_image">
                      <img src={data[s].image} className="w-100" alt={s} loading="lazy"/>
                    </div>

                    <div className="text-center programs_text">
                      <div className="fo-14 justify">{data[s].text}</div>
                    </div>
                  </div>
                </SplideSlide>
              );
            })}
          </Splide>
        </div>

        <div className="long-mt">
          <div className="ps-xl-5 pe-xl-5">
            <div className="row m-0 ps-lg-5 pe-lg-5 mt-5 mb-5">
              <div className="col-6 col-sm-6 col-md-3 text-center">
                <img
                  src="/assets/program6.png"
                  className="w-80 m-auto"
                  alt="Programmes"
                />
                <div className="fo-20 fw-700 txtco mt-3 mfo-16">
                  Dedicated Coach
                </div>
                <div className="fo-14 mt-3 mb-4 mfo-11">
                  A health coach shall create a custom plan for you based on
                  their expertise and you requirement. They shall be accessible
                  throughout your fitness and wellness journey and offer you
                  motivation if you ever lose sight of your vision.
                </div>
              </div>
              <div className="col-6 col-sm-6 col-md-3 text-center">
                <img
                  src="/assets/program7.png"
                  className="w-80 m-auto"
                  alt="Programmes"
                />
                <div className="fo-20 fw-700 txtco mt-3 mfo-16">
                  Sustainable Results
                </div>
                <div className="fo-14 mt-3 mb-4 mfo-11">
                  Our plans shall ensure that you’re empowered with the
                  information and know-how to maintain your results even after
                  your programme has ended. This shall allow you to hold to the
                  health you've attained for an indefinite time period.
                </div>
              </div>
              <div className="col-6 col-sm-6 col-md-3 text-center">
                <img
                  src="/assets/program8.png"
                  className="w-80 m-auto"
                  alt="Programmes"
                ></img>
                <div className="fo-20 fw-700 txtco mt-3 mfo-16">
                  Online Community
                </div>
                <div className="fo-14 mt-3 mb-4 mfo-11">
                  Be a part of an awesome global community of health-enthusiasts
                  of around 20000+ individuals working towards the shared common
                  goal of building a world that’s fitter, healthier and happier!
                  Reaching your goals has never been easier!
                </div>
              </div>
              <div className="col-6 col-sm-6 col-md-3 text-center">
                <img
                  src="/assets/program9.png"
                  className="w-80 m-auto"
                  alt="Programmes"
                ></img>
                <div className="fo-20 fw-700 txtco mt-3 mfo-16">
                  Board of Doctors
                </div>
                <div className="fo-14 mt-3 mb-4 mfo-11">
                  Our coaching methodologies are approved by medical health
                  professionals and research scholars who associate with us to
                  work on clinical cases such Diabetes, PCOS, Thyroid,
                  Intolerances, Allergies, Gastrointestinal Disorders etc.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <SuccessStorySection />

      <div className="text-center">
        <div className="bco fo-34 fw-700 mt-90 mfo-22">
          Start your health journey with us from today!
        </div>
        <Link href="/chooseProgram">
          <a>
            <div className="tablet consultButton pulsating prog">Start Now</div>
          </a>
        </Link>
      </div>
    </div>
  );
};

export default Programs;
